import { useCallback } from "react";
import { useAddressSystemPageAccess } from "../../hooks/useAddressSystemPageAccess";
import { reportLinks, ReportView } from "./landing/reportsLandingData";

export function useReportsPageAccess() {
  const { visibleItems, isItemVisible } = useAddressSystemPageAccess(reportLinks);

  const isViewVisible = useCallback(
    (view: ReportView) => {
      if (view === "landing") {
        return true;
      }

      const link = reportLinks.find((item) => item.navigationTarget === view);
      return link != null && isItemVisible(link.id);
    },
    [isItemVisible],
  );

  return {
    visibleLinks: visibleItems,
    isViewVisible,
  };
}
